export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.

        window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.

        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)
export const isCloudfront = Boolean(window.location.hostname.endsWith('.cloudfront.net'))

// export const redirectSignIn = awsconfig => {
//   // Assuming you have two redirect URIs, and the first is for localhost and second is for production

//   const localRedirectSignIn = awsconfig.oauth.redirectSignIn.split(',')[0]

//   const productionRedirectSignIn = isCloudfront
//     ? awsconfig.oauth.redirectSignIn.split(',')[1]
//     : awsconfig.oauth.redirectSignIn.split(',')[2]

//   const redirectSignIn = isLocalhost
//     ? localRedirectSignIn
//     : productionRedirectSignIn

//   return redirectSignIn
// }

export const redirectSignIn = awsconfig => {
  // Assuming you have two redirect URIs, and the first is for localhost and second is for production
  console.log('awsconfig.oauth.redirectSignIn: ', awsconfig.oauth.redirectSignIn)
  console.log('window.location.hostname: ', window.location.hostname)
  console.log('window.location.href: ', window.location.href)
  console.log('isCloudfront: ', isCloudfront)
  console.log('isLocalhost: ', isLocalhost)

  const localRedirectSignIn = awsconfig.oauth.redirectSignIn.split(',')[0]

  let productionRedirectSignIn

  if (isCloudfront) {
    console.log('isCloudfront inside if')
    for (const url of awsconfig.oauth.redirectSignIn.split(',')) {
      const { hostname } = new URL(url)
      // console.log('hostname: ', hostname)
      // console.log('url: ', url)
      if (hostname.endsWith('.cloudfront.net')) {
        productionRedirectSignIn = url
        break
      }
    }
  } else {
    console.log('isCloudfront inside else')
    for (const url of awsconfig.oauth.redirectSignIn.split(',')) {
      const { hostname } = new URL(url)
      // console.log('hostname: ', hostname)
      // console.log('url: ', url)
      if (hostname.endsWith('.sizeo.ai')) {
        productionRedirectSignIn = url
        break
      }
    }
  }
  console.log(productionRedirectSignIn)
  const redirectSignIn = isLocalhost ? localRedirectSignIn : productionRedirectSignIn

  return redirectSignIn
}

export const redirectSignOut = awsconfig => {
  // Assuming you have two redirect URIs, and the first is for localhost and second is for production
  console.log('awsconfig.oauth.redirectSignIn: ', awsconfig.oauth.redirectSignOut)
  console.log('window.location.hostname: ', window.location.hostname)
  console.log('window.location.href: ', window.location.href)
  console.log('isCloudfront: ', isCloudfront)
  console.log('isLocalhost: ', isLocalhost)

  const localRedirectSignOut = awsconfig.oauth.redirectSignOut.split(',')[0]

  let productionRedirectSignOut
  if (isCloudfront) {
    for (const url of awsconfig.oauth.redirectSignOut.split(',')) {
      const { hostname } = new URL(url)
      // console.log('hostname: ', hostname)
      // console.log('url: ', url)
      if (hostname.endsWith('.cloudfront.net')) {
        productionRedirectSignOut = url
        break
      }
    }
  } else {
    for (const url of awsconfig.oauth.redirectSignOut.split(',')) {
      const { hostname } = new URL(url)
      // console.log('hostname: ', hostname)
      // console.log('url: ', url)
      if (hostname.endsWith('.sizeo.ai')) {
        productionRedirectSignOut = url
        break
      }
    }
  }

  const redirectSignOut = isLocalhost ? localRedirectSignOut : productionRedirectSignOut

  return redirectSignOut
}
